import React, { useEffect, useState } from 'react';
import { HashIcon } from 'lucide-react';
import { GlassCard } from './GlassCard';
import { SparklineCard } from './SparklineCard';
import { motion } from 'framer-motion';
const messages = [{
  user: 'Emma Chen',
  avatar: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&q=80&w=150',
  message: 'Hey team! Just wanted to give a shoutout to everyone for the amazing work on the new release! 🎉',
  time: '2:30 PM'
}, {
  user: 'James Wilson',
  avatar: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?auto=format&fit=crop&q=80&w=150',
  message: "Absolutely! The cross-team collaboration has been incredible. We're shipping faster than ever! 🚀",
  time: '2:31 PM'
}, {
  user: 'Sophia Patel',
  avatar: 'https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?auto=format&fit=crop&q=80&w=150',
  message: 'Love how everyone jumped in to help with user testing. Really shows our team spirit! 💪',
  time: '2:32 PM'
}, {
  user: 'Marcus Kim',
  avatar: 'https://images.unsplash.com/photo-1568602471122-7832951cc4c5?auto=format&fit=crop&q=80&w=150',
  message: 'The daily stand-ups have been so energizing lately. Great mix of focus and fun!',
  time: '2:33 PM'
}, {
  user: 'Lisa Zhang',
  avatar: 'https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?auto=format&fit=crop&q=80&w=150',
  message: 'And those virtual coffee chats are really helping us stay connected! ☕️',
  time: '2:34 PM'
}, {
  user: 'David Chen',
  avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&q=80&w=150',
  message: "Agreed! The team's energy is contagious. Makes working remote feel much more connected 🤝",
  time: '2:35 PM'
}, {
  user: 'Emma Chen',
  avatar: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&q=80&w=150',
  message: "So proud of this team! Here's to keeping this momentum going! 🎯",
  time: '2:36 PM'
}];
export const EngagementThread = () => {
  const [isInView, setIsInView] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setIsInView(true);
      }
    }, {
      threshold: 0.5
    });
    const element = document.querySelector('.engagement-thread-container');
    if (element) {
      observer.observe(element);
    }
    return () => observer.disconnect();
  }, []);
  return <div className="w-full h-full bg-white relative engagement-thread-container" data-id="element-206">
      {/* Channel Header */}
      <motion.div className="bg-gray-50 border-b border-gray-200 px-4 py-2 flex items-center" animate={{
      opacity: isInView ? 0 : 1
    }} transition={{
      duration: 0.5,
      delay: 0.35,
      ease: 'easeOut'
    }} data-id="element-207">
        <HashIcon size={18} className="text-gray-500 mr-2" data-id="element-208" />
        <span className="text-gray-800 font-medium" data-id="element-209">team-general</span>
        <span className="ml-2 text-gray-500 text-sm" data-id="element-210">15 members</span>
      </motion.div>
      {/* Messages Container */}
      <motion.div className="p-4 space-y-4" style={{
      filter: 'blur(1.5px) saturate(0.7)'
    }} animate={{
      y: isInView ? [-400, -800] : 0
    }} transition={{
      duration: 20,
      repeat: Infinity,
      ease: 'linear',
      repeatType: 'loop'
    }} data-id="element-211">
        {[...messages, ...messages, ...messages].map((msg, index) => <div key={index} className="flex items-start" data-id="element-212">
            <img src={msg.avatar} alt={msg.user} className="w-8 h-8 rounded mr-3" data-id="element-213" />
            <div data-id="element-214">
              <div className="flex items-baseline" data-id="element-215">
                <span className="font-bold text-gray-900 mr-2" data-id="element-216">{msg.user}</span>
                <span className="text-xs text-gray-500" data-id="element-217">{msg.time}</span>
              </div>
              <p className="text-gray-800 mt-1" data-id="element-218">{msg.message}</p>
            </div>
          </div>)}
      </motion.div>
      {/* Glass Card Overlay */}
      <motion.div className="absolute top-1/2 left-1/2" style={{
      x: '-50%',
      y: '-50%'
    }} initial={{
      opacity: 0,
      y: 'calc(-50% + 20px)'
    }} animate={{
      opacity: isInView ? 1 : 0,
      y: isInView ? '-50%' : 'calc(-50% + 20px)'
    }} transition={{
      duration: 0.35,
      ease: [0.25, 0.46, 0.45, 0.94]
    }} data-id="element-219">
        <SparklineCard isInView={isInView} value={74} trend="+5" title="Engagement" data-id="element-220" />
      </motion.div>
    </div>;
};